<template>
  <div v-if="activeVenue">

    <div v-if="activeTab == 0" class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
      <eod-reports-list />
    </div>

  </div>
</template>

<script>
import EodReportsList from "./EodReportsList.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    EodReportsList
  },
  data() {
    return {
      activeTab: 0
    };
  },
  methods: {},
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue"
    }),

    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    loading() {
      return this.$store.state.venues.loading || this.$store.state.venues.allLoading;
    }
  },
  watch: {
    // eslint-disable-next-line
    loading: function (nS, ds) {
      if (nS) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },

  created() {}
};
</script>

<style lang="scss">
#nested-tabs {
  .con-ul-tabs {
    float: none !important;
    height: auto !important;
    display: auto !important;
  }
  .vs-tabs--ul {
    display: flex !important;
    flex-wrap: wrap !important;
    border: 0 !important;
  }
  .line-vs-tabs {
    left: 0px !important;
  }
}
</style>
